import React, { useCallback } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "locales";
import useComponentVisible from "hooks/useComponentVisible";
import BaseButton from "../../../BaseButton";
import BaseIcon from "../../../BaseIcon";
import "./style.scss";

interface Props {
  className?: string;
}

function Navigation({ className }: Props) {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { t } = useTranslation();

  const cls = ["navigation"];
  if (className) cls.push(className);

  const toggleMenu = () => {
    setIsComponentVisible(!isComponentVisible);
  };

  const onClickItem = useCallback(() => {
    setIsComponentVisible(false);
  }, [setIsComponentVisible]);

  const links = [
    { to: "/", label: t("Home") },
    { to: "/services", label: t("Services") },
    { to: "/coaches", label: t("Find a Coach") },
    { to: "/who-we-help", label: t("Who We Help") },
    { to: "/insights", label: t("Insights") },
    { to: "/about-us", label: t("About") },
  ];

  return (
    <div className={cls.join(" ")} ref={ref}>
      <div className="navigation__activator mr-2">
        <BaseButton borderless icon className="navigation__burger-button" onClick={toggleMenu}>
          <BaseIcon className={isComponentVisible ? "d-block" : "d-none"} size={"24"}>
            close
          </BaseIcon>
          <BaseIcon className={isComponentVisible ? "d-none" : "d-block"} size={"24"}>
            menu
          </BaseIcon>
        </BaseButton>
      </div>
      <div className={"navigation__content" + (isComponentVisible ? " __active" : "")}>
        <nav className="navigation__nav">
          {links.map((link) => (
            <NavLink key={link.to} className="link navigation__nav-link" to={link.to} exact onClick={onClickItem}>
              {link.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}

export default Navigation;
